export default [
  { label: 'Doradca ds. sprzedaży', value: 'HANDLOWIEC' },
  { label: 'Kierownik sprzedaży', value: 'HEAD_OF_SALES' },
]
